import {
  IconHomeTypeFilled,
  IconMailFilled,
  IconMegaphoneFilled,
  IconMonitorFilled,
} from '@zillow/constellation-icons';

const PREMIUM_FEATURES_BY_CONTEXT = {
  MORE_EXPOSURE: {
    PAY_AND_PUBLISH: {
      HEADING: 'More exposure',
      BODY: 'Renters searching in your area will see your listing more often, so you can fill your vacancy faster.',
      ICON: IconMegaphoneFilled,
    },
  },
  LISTING_RECS: {
    PAY_AND_PUBLISH: {
      HEADING: 'Listing recommendations',
      BODY: 'Appeal to more renters by following our customized tips.',
      ICON: IconHomeTypeFilled,
    },
  },
  PRICE_AND_MARKET_INSIGHTS: {
    PAY_AND_PUBLISH: {
      HEADING: 'Pricing & market insights',
      BODY: 'Track your listing’s performance and trends in your market to find out if you’ve positioned your rental competitively.',
      ICON: IconMonitorFilled,
    },
  },
  PRIORITY_SUPPORT: {
    PAY_AND_PUBLISH: {
      HEADING: 'Priority support',
      BODY: 'Save time and effort with prioritized responses to your questions.',
      ICON: IconMailFilled,
    },
  },
};

const PRODUCT_TYPE_NAME_TO_ID = {
  FREE: 5,
  PREMIUM: 6,
};

const PRODUCT_TYPE_ID_TO_NAME = {
  5: 'Free',
  6: 'Premium',
};

export { PREMIUM_FEATURES_BY_CONTEXT, PRODUCT_TYPE_NAME_TO_ID, PRODUCT_TYPE_ID_TO_NAME };
